import { action, extendObservable } from 'mobx';
import PropTypes from 'prop-types';
import InputStore from '../InputStore';
import copyText from '../../copyText';

export default class AuthConfCreateStore {
    static PropType = PropTypes.shape({
        apiKey: InputStore.PropType.isRequired,
        secret: InputStore.PropType.isRequired,
        tenantURL: InputStore.PropType.isRequired,
    });

    constructor(data = {}) {
        extendObservable(this, /** @class AuthConfCreateStore */ {
            apiKey: new InputStore(),
            secret: new InputStore(),
            // tenantURL: new InputStore(),
        }, data);
    }

    setValue = action((key, secret) => {
        this.apiKey.setValue(key);
        this.secret.setValue(secret);
    });

    copyTextToClipboard = (text) => copyText(text);
}
